import { FilterItem, SectionKey, TagStyle, SearchType } from './rule-detail.types';
import { TARGET_OPTIONS } from './rule-detail.constants';

// Reverse-map a target type name to its category
export const getCategoryForTarget = (targetValue: string): string => {
  for (const [category, targets] of Object.entries(TARGET_OPTIONS)) {
    if (targets.some(t => t.value === targetValue)) return category;
  }
  return '';
};

// Determine search type from the selected target
export const getSearchType = (target: string): SearchType | null => {
  const lower = target.toLowerCase();
  if (lower.includes('user')) return 'user';
  if (lower.includes('hashtag')) return 'hashtag';
  if (lower.includes('place')) return 'place';
  return null; // keywords = manual entry, no search
};

// Normalize a rule status string to a lowercased/underscored key
export const normalizeStatus = (status: string | undefined | null): string =>
  status?.toLowerCase().replace(/\s+/g, '_') || 'active';

// Group criteria into sections
export const groupCriteria = (
  criteria: FilterItem[]
): Record<SectionKey, Record<string, FilterItem[]>> => {
  const sections: Record<SectionKey, Record<string, FilterItem[]>> = {
    users: {},
    posts: {},
    reels: {},
  };

  criteria.forEach(item => {
    let section: SectionKey;
    if (item.type.includes('Reels')) {
      section = 'reels';
    } else if (item.type.startsWith('User')) {
      section = 'users';
    } else {
      section = 'posts';
    }
    if (!sections[section][item.type]) {
      sections[section][item.type] = [];
    }
    sections[section][item.type].push(item);
  });

  return sections;
};

// Tag color styles by criteria type
export const getTagStyle = (type: string, isDark: boolean): TagStyle => {
  if (type.startsWith('User')) {
    return {
      bg: isDark ? '#162456' : '#EFF6FF',
      color: isDark ? '#8EC5FF' : '#2B7FFF',
      xColor: isDark ? '#2B7FFF' : '#155DFC',
    };
  }
  if (type.includes('#Hashtags')) {
    return {
      bg: isDark ? '#3C0366' : '#FAF5FF',
      color: isDark ? '#DAB2FF' : '#AD46FF',
      xColor: isDark ? '#AD46FF' : '#9810FA',
    };
  }
  if (type.includes('Keyword')) {
    return {
      bg: isDark ? '#053345' : '#ECFFFE',
      color: isDark ? '#53EAFD' : '#00B8DB',
      xColor: isDark ? '#00B8DB' : '#0891B2',
    };
  }
  if (type.includes('Places')) {
    return {
      bg: isDark ? '#022C22' : '#ECFDF5',
      color: isDark ? '#5EE9B5' : '#009966',
      xColor: isDark ? '#00BC7D' : '#047857',
    };
  }
  return {
    bg: isDark ? '#162456' : '#EFF6FF',
    color: isDark ? '#8EC5FF' : '#2B7FFF',
    xColor: isDark ? '#2B7FFF' : '#155DFC',
  };
};
